import {insertScript} from '../shared/script';
import {deferredValue} from '../shared/util';

export type gapi = any;
export type ClientConfig = any;
export type GoogleAuth = any;
export type GoogleUser = any;

const libValue = deferredValue(() => new Promise<gapi>(resolve => {
  insertScript({
    src: 'https://apis.google.com/js/platform.js',
    onload: () => resolve((window as any).gapi),
    async: true,
    defer: true,
  });
}));

export const googleApi = {
  get gapi() {
    return libValue();
  },
  load(libraries: string, timeout = 5000): Promise<void> {
    return new Promise(async (resolve, reject) => (await googleApi.gapi).load(libraries, {
      callback: resolve,
      onerror: () => reject('gapi.client failed to load.'),
      ontimeout: () => reject('gapi.client timed out.'),
      timeout,
    }));
  },
  initAuth(params: ClientConfig): Promise<{googleAuth: GoogleAuth}> {
    // https://developers.google.com/identity/sign-in/web/reference#googleauththenoninit-onerror
    return new Promise(async (resolve, reject) => {
      (await googleApi.gapi).auth2.init(params)
        .then((googleAuth: GoogleAuth) => resolve({googleAuth}), reject);
    });
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/core/google-api.ts